module.exports = __webpack_public_path__ + "img/newchris-87.7bcda647.jpg";